/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-list[_ngcontent-%COMP%], .mat-nav-list[_ngcontent-%COMP%], .mat-selection-list[_ngcontent-%COMP%]{border:1px solid rgba(0,0,0,.12);margin:20px 20px 0 0}h2[_ngcontent-%COMP%]{margin-top:20px}.mat-icon[_ngcontent-%COMP%]{color:rgba(0,0,0,.12)}.mat-list-icon[_ngcontent-%COMP%]{color:#fff;background:rgba(0,0,0,.3)}a[_ngcontent-%COMP%]{text-decoration:none!important}.min-height-65[_ngcontent-%COMP%]{min-height:65px}"];
export { styles as styles };
